import { render, staticRenderFns } from "./FaqDelete.vue?vue&type=template&id=3bfc7fa9&"
import script from "./FaqDelete.vue?vue&type=script&lang=js&"
export * from "./FaqDelete.vue?vue&type=script&lang=js&"
import style0 from "./FaqDelete.vue?vue&type=style&index=0&id=3bfc7fa9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports